import {BaseMyopMessage} from "./BaseMessage";

export class DisposeMessage extends BaseMyopMessage {
    messageType = 'DisposeMessage';
}
